import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services';
import { usePermissions } from '../hooks/usePermissions';

/**
 * Permission-based route guard.
 * Supports both the new `requiredPermission` prop and the legacy `allowedRoles` prop
 * for backward compatibility during migration.
 */
const RoleProtectedRoute = ({ children, allowedRoles, requiredPermission }) => {
  const isAuthenticated = authService.isAuthenticated();
  const { hasPermission, hasAnyPermission, loading } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If a specific permission is required, check it
  if (requiredPermission) {
    if (loading) {
      return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
    }
    
    const requiredPerms = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
    if (!hasAnyPermission(requiredPerms)) {
      return <Navigate to="/home" replace />;
    }
  } else if (allowedRoles) {
      // Legacy role-based check - during full UBAC implementation, if a route is protected
      // but lacks requiredPermission, we should evaluate if we need to block it.
      // We will allow it for now IF the user belongs to the allowedRole, but in a strict UBAC,
      // it should be blocked. Since we are moving to UBAC, we'll keep the legacy check active
      // ONLY if there is no requiredPermission yet.
      // Wait, the plan was to remove the bypass. If we want strict block:
      const userRole = (authService.getUser()?.roleName || authService.getUser()?.RoleName || '').toLowerCase();
      const allowedRolesLower = allowedRoles.map(r => r.toLowerCase());
      
      if (!allowedRolesLower.includes(userRole)) {
          return <Navigate to="/home" replace />;
      }
  }

  return children;
};

export default RoleProtectedRoute;
